import * as React from 'react'

import { cn } from '@/lib/utils'
import { useTextEntryHydration } from './text-entry-hydration'

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  // Inert until React can hear it — see useTextEntryHydration.
  const hydration = useTextEntryHydration(props)

  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'border-input dark:bg-input/30 focus-visible:border-ring aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:aria-invalid:border-destructive/50 disabled:bg-input/50 dark:disabled:bg-input/80 rounded-lg border bg-transparent px-2.5 py-2 text-base transition-colors aria-invalid:ring-3 md:text-sm placeholder:text-muted-foreground flex field-sizing-content min-h-16 w-full outline-none disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
      {...hydration}
    />
  )
}

export { Textarea }
